import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { db } from 'firebase/index'
import { CouponType } from 'types/coupon'
import { fetchCouponsAction } from 'reducks/coupon/actions'

const changeCouponStatus = (couponId: string, status: 'public' | 'private') => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    if (!couponId) return
    await db.collection('coupons').doc(couponId).set({ status }, { merge: true })
    const prevCoupons = getState().coupon.coupons
    const nextCoupons = prevCoupons.map((prevCoupon: CouponType) => {
      if (prevCoupon.coupon_id && prevCoupon.coupon_id === couponId) {
        prevCoupon.status = status
        return prevCoupon
      } else {
        return prevCoupon
      }
    })
    dispatch(fetchCouponsAction(nextCoupons))
  }
}

export default changeCouponStatus
